import React,{ useEffect } from 'react';

import AuthLayout from '../../../layouts/AuthLayout/AuthLayout';
import { LoginForm } from '../../../components';
import { APP_URL } from '../../../constants';

const login = () => {

  // console.log("APP ENV URL", APP_URL);
  
  return (
    <AuthLayout pageName="login">
      <LoginForm />
    </AuthLayout>
  );
};

export default login;
